const getEmptyTableMessage = (pluralFormNoun, buttonName) =>
  `There are no ${pluralFormNoun}, please add them using the ${buttonName} button.`

const getEmptyTableOnSearchMessage = (pluralFormNoun) =>
  `There are no ${pluralFormNoun} matching your search criteria.`

module.exports = { getEmptyTableMessage, getEmptyTableOnSearchMessage }
